export const environment = {
  production: false,
  apiBaseUrl: 'https://api.demo.pixacare.com',
  appInsights: {
    instrumentationKey: 'TODO',
  },
};
